import { appPrefixedHostWithProtocol } from "@novel/shared/utils/appDomainConstants";
import { redirectOnFrontend } from "@novel/shared/utils/locationUtils";
import { stringify } from "qs";
import React, { useState } from "react";
export function SignOutButton({
  buttonSmall
}: {
  readonly buttonSmall?: boolean;
}): JSX.Element {
  const [signOutloading, setSignOutloading] = useState(false);
  const logout = async () => {
    setSignOutloading(true);
    redirectOnFrontend(`${appPrefixedHostWithProtocol}/api/customer/auth/logout${stringify({
      redirectUrl: encodeURIComponent("/gallery/login")
    }, {
      addQueryPrefix: true
    })}`);
  };
  return <button onClick={logout} className={`m-width-121 ml-2 full-button full-outline-color ${!signOutloading ? "" : "full-button-load"}${!buttonSmall ? "" : " small-button"}`} disabled={signOutloading}>
            {!signOutloading ? "Sign Out" : <div style={{
      borderTopColor: "transparent",
      display: "inline-block",
      width: 15,
      height: 15
    }} className="border-4 border-solid rounded-full animate-spin border-slate-200" />}
        </button>;
}